import axios from 'axios';
import config from '../../config';

const baseUrl = config.baseUrl;
const orgEndpoint = '/api/participantesFinalesArt';

/**
 * Obtiene participantes finales para Excel ART
 * @param {number} oidProyecto
 */
const getParticipantesFinalesArt = async (oidProyecto) => {
  try {
    const response = await axios.get(`${baseUrl}${orgEndpoint}`, {
  params: { oidProyecto }
});
    return {
      status: response.status,
      data: response.data.data // 👈 coincide con el controller
    };
  } catch (error) {
    console.error('❌ Error fetching ParticipantesFinalesArt:', error);

    return {
      status: error.response ? error.response.status : 500,
      message: 'Error fetching participantes finales ART'
    };
  }
};

export default getParticipantesFinalesArt;
